import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/alert.vue';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
